import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-recurso-educativo',
  templateUrl: './recurso-educativo.component.html',
  styleUrls: ['./recurso-educativo.component.scss']
})
export class RecursoEducativoComponent implements OnInit {


  /*** RECURSOS ***/

  blog: any;

  pag: any = {
    list: [],
    firstPage: 1,
    lastPage: 1,
    perPage: 10,
    page: 0
  }
  search: string = '';

  /*** TEMAS Y TIPOS ***/
  webcontext: any;
  webcollection: any;

  /*** TEMAS Y TIPOS URL ***/
  context: any;
  collection: any;

  /*** TEMAS Y TIPOS SELECCIONADOS ***/
  currentContext: any;
  currentCollection: any;

  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public api: RestapiService,
    public seo : SeoService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.pag = {
          list: [],
          firstPage: 1,
          lastPage: 1,
          perPage: 10,
          page: 0
        }
        delete this.blog;
        this.context = this.activatedRoute.snapshot.paramMap.get('context');
        this.collection = this.activatedRoute.snapshot.paramMap.get('collection');
        this.loadFilters();
        this.loadContent(this.pag.firstPage);
      }, 10);
    });
  }

  ngOnInit(): void {
    this.context = this.activatedRoute.snapshot.paramMap.get('context');
    this.collection = this.activatedRoute.snapshot.paramMap.get('collection');
    console.log('collection', this.collection);
    console.log('context', this.context);
    this.seo.generateTags({
      title:'WWF Educación Ambiental, Recursos didácticos',
      description: 'Recursos didácticos',
      image: '/assets/brand.png',
      slug: window.location.href,
    });
    this.loadFilters();
    this.loadContent(this.pag.firstPage);
  }

  loadFilters() {
    this.api.getdata('webcollection', { per_page: 100 })
      .subscribe(res => {
        console.log('webcollection', res)
        res.status == true ? this.webcollection = res.result.data : '';
        this.getCollection(this.collection);
      });
    this.api.getdata('webcontext', { per_page: 100, filters: { webroute_id: { value: 6 } } })
      .subscribe(res => {
        res.status == true ? this.webcontext = res.result.data : '';
      });
  }

  paginationBuild() {
    this.pag.list = [];
    if (this.pag.lastPage && this.pag.page) {
      this.pag.list.push({ value: 'prev', label: '<', hidden: false });
      this.pag.list.push({ value: 'backward', label: '...', hidden: false });
      for (let i = 1; i <= this.pag.lastPage; i++) {
        this.pag.list.push({ value: i, label: i, hidden: true });
      }
      this.pag.list.push({ value: 'forward', label: '...', hidden: false });
      this.pag.list.push({ value: 'next', label: '>', hidden: false });
      let criteria = this.pag.page == 1 || this.pag.page == this.pag.lastPage ? 2 : 1;
      this.pag.list.forEach((v, k) => {
        (v.value == 'backward' && this.pag.page <= (1 + 1)) ? v.hidden = true : '';
        (v.value == 'forward' && this.pag.page >= (this.pag.lastPage - 1)) ? v.hidden = true : '';
        if (Number.isInteger(v.value) === true && (v.value == this.pag.page
          || v.value == this.pag.page - 1
          || v.value == this.pag.page + 1
          || v.value == this.pag.page - criteria
          || v.value == this.pag.page + criteria
        )) {
          v.hidden = false;
        }
      })
    }
  }
  paginate(nextPage: any) {
    switch (nextPage) {
      case 'infinite':
        this.pag.page++;
        break;
      case 'next':
        (this.pag.page + 1 <= this.pag.lastPage) ? this.pag.page++ : '';
        break;
      case 'prev':
        (this.pag.page - 1 >= 1) ? this.pag.page-- : '';
        break;
      case 'forward':
        (this.pag.page + 2 <= this.pag.lastPage) ? this.pag.page += 2 : '';
        break;
      case 'backward':
        (this.pag.page - 2 >= 1) ? this.pag.page -= 2 : '';
        break;
      default:
        this.pag.page = nextPage;
        break;
    }
  }
  onchange(event: any) {
    console.log('onchange', event.target.value);
    this.search = event.target.value;
    this.loadContent(this.pag.page);
  }

  loadContent(nextPage?: any) {
    // this.page++;
    this.paginate(nextPage);
    this.pag.page === 1 ? this.blog = [] : '';
    this.api.getdata(this.collection == 'Ficha-digital' ? 'websection' : 'webresource', {
      page: this.pag.page,
      per_page: this.pag.perPage,
      filters: {
        // webcollection_id: {value: 3},
        name: { value: this.collection != 'Ficha-digital' ? this.search : '', operator: 'like' },
        title: { value: this.collection == 'Ficha-digital' ? this.search : '', operator: 'like' },
        webcontext_id: { model: 'webcontext', value: (this.context != 'todos') ? this.context : '', field: 'name', operator: 'belongsTo' },
        webcollection_id: { model: 'webcollection', value: this.collection, field: 'name', operator: 'belongsTo' }
      },
    }).subscribe(res => {
      if (res.status == true) {
        console.log(this.collection == 'Ficha-digital' ? 'EXIT websection' : 'EXIT webresource', res);
        this.pag.lastPage = res.result.last_page;
        this.pag.from = res.result.from;
        this.pag.to = res.result.to;
        this.pag.total = res.result.total;
        if (res.result.data.length > 0) {
          if (nextPage === 'infinite') {
            res.result.data.forEach(el => {
              this.blog.push(el);
            });
          }
          else {
            this.blog = res.result.data;
          }
          console.log('BLOG LOADED', this.blog)
          this.paginationBuild();
        }
      }
    })
  }

  onScroll() {
   //if (this.pag.page < this.pag.lastPage) {
   //  this.loadContent('infinite');
   //} else {
   //  console.log('No more lines. Finish page!');
   //}
  }

  getCollection(searched) {
    this.webcollection.forEach(el => {
      if (searched == el.name) {
        console.log('MATCH', el)
        this.currentCollection = el;
      }
    });
  }

  pickCollection(context) {
    this.route.goTo('recursos-didacticos/' + this.collection + '/' + context);
  }

  pickContext(item) {
    this.route.goTo('recursos-didacticos/' + this.collection + '/' + item.name);
  }



}
